module.exports = __webpack_public_path__ + "img/aa2.2d7c703f.jpg";